export const environment = {
  production: false,
  groupName: "--",
  BusinessUnit:"SOUTHERN AFRICA",
  apiUrl: "https://doa-sasbu-api-test.azure.chevron.com/api",
  scope:"https://doa-sasbu-test.azure.chevron.com/user_impersonation",
  histroyReportUrl:"https://app.powerbi.com/reportEmbed?reportId=b0eda8d0-34a1-43b5-b03e-312120256287&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  logReportUrl:"https://app.powerbi.com/reportEmbed?reportId=87d68b62-5a37-469c-9142-b970d2a39e96&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  integrityReportUrl:"https://app.powerbi.com/reportEmbed?reportId=7a03a480-24ff-4d00-a7b3-2292c787e687&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  masterReportUrl:"https://app.powerbi.com/reportEmbed?reportId=60bd4cf5-a289-44a6-852c-9cfcac0c9f97&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26"
  
  
};
